import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";

import { ENV, IS_LOCALHOST } from "@/src/const";

interface RUMProps {
  hostname: string;
}

function RUM({ hostname }: RUMProps) {
  useEffect(() => {
    if (IS_LOCALHOST) {
      return;
    }

    datadogRum.init({
      applicationId: "409b3cd1-3ab3-4081-94cb-b7030d4eccf2",
      clientToken: "pub9ae1a5bd1ff03fcfa0f1fffde7ef388c",
      site: "us5.datadoghq.com",
      service: (hostname ?? "").replace(/\./g, "_") ?? "flow-websites",
      env: ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 5,
      defaultPrivacyLevel: "mask-user-input",
    });
  }, [hostname]);

  return <></>;
}

export default RUM;
